import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import Component from './Component';
import {getCartTours, deleteFromCart, changeTourData, setMetingPlace} from './Actions';

const stateToProps = (state) => ({
  toursList: state.cart.toursList,
  listInCart: state.cart.list,
  cities: state.main.cities,
});

const dispatchToProps = (dispatch) => ({
  getCartTours: () => {
    dispatch(getCartTours())
  },
  deleteFromCart: (id, tourList) => {
    dispatch(deleteFromCart(id, tourList))
  },
  changeTourData: (d) => {
    dispatch(changeTourData(d))
  },
  setMetingPlace: (d) => {
    dispatch(setMetingPlace(d))
  }
});

export default withRouter(connect(stateToProps, dispatchToProps)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/Cart/index.js